import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=64e2302c&scoped=true&"
import script from "./TextButton.vue?vue&type=script&lang=js&"
export * from "./TextButton.vue?vue&type=script&lang=js&"
import style0 from "./TextButton.vue?vue&type=style&index=0&id=64e2302c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2302c",
  null
  
)

export default component.exports